import React from "react";
import { DEFAULT_PRIVILEGE } from "../../decision/importColumns.mjs";

export const PRIVILEGE_OPTIONS = [
  { value: 1, label: "1 — без пільги" },
  { value: 2, label: "2 — ВПО, соціально вразливі" },
  { value: 3, label: "3 — діти УБД, загиблих захисників, сироти" },
];

// Пільга p (1..3) -- жорстке обмеження черги, не критерій. Типове значення
// береться з файлу (колонка "Пільга"), а якщо її немає -- 1; цей селект дає
// вручну виправити його для конкретного рядка.
const PrivilegeSelect = ({ value, onChange, ariaLabel }) => {
  const current = value === null || value === undefined ? DEFAULT_PRIVILEGE : value;
  return (
    <select
      className="header-content-select"
      aria-label={ariaLabel || "Пільга"}
      value={current}
      onChange={(e) => onChange(Number(e.target.value))}
    >
      {PRIVILEGE_OPTIONS.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default PrivilegeSelect;
